import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 登录历史 — 只读审计.
 */
export const loginHistoryConfig: CrudConfig = {
  resource: 'login-history',
  title: '登录历史',
  rowKey: 'id',
  searchFields: ['status', 'login_method'],
  disableCreate: true,
  disableEdit: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true },
    { name: 'user_email', label: '用户', type: 'readonly', width: 200, ellipsis: true, readonly: true },
    {
      name: 'login_method',
      label: '登录方式',
      type: 'select',
      width: 120,
      readonly: true,
      options: [
        { label: '密码', value: 'PASSWORD', color: 'blue' },
        { label: '验证码', value: 'EMAIL_CODE', color: 'cyan' },
        { label: '微信', value: 'WECHAT', color: 'green' },
        { label: 'Google', value: 'GOOGLE' },
        { label: 'Apple', value: 'APPLE' },
        { label: 'LinkedIn', value: 'LINKEDIN' },
      ],
    },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 100,
      readonly: true,
      options: [
        { label: '成功', value: 'SUCCESS', status: 'Success', color: 'green' },
        { label: '失败', value: 'FAILED', status: 'Error', color: 'red' },
        { label: '风险拦截', value: 'BLOCKED', color: 'orange' },
      ],
    },
    { name: 'ip_address', label: 'IP', type: 'text', width: 140, readonly: true, copyable: true },
    { name: 'user_agent', label: 'User-Agent', type: 'text', hideInTable: true, readonly: true },
    { name: 'device_fingerprint', label: '设备指纹', type: 'text', width: 200, readonly: true, hideInTable: true },
    { name: 'risk_score', label: '风险评分', type: 'number', width: 100, readonly: true },
    { name: 'failure_reason', label: '失败原因', type: 'text', hideInTable: true, readonly: true },
    { name: 'created_at', label: '登录时间', type: 'datetime', width: 180, readonly: true },
  ],
};
